import React from "react";
import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as GC from "../../../common/common";
import $ from "jquery";
import Variable from "./variable/v";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";
import { CONSTS } from "../../../common/const";
import bijlage from "../../../../content/images/bijlage.svg";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
    window.$catalog_measures_context = this
  }
  /*** ---TABLONUN İÇİNE DEĞERLERİ GETİREN FONKSİYON--- ***/
  async fillTable(model, page_number) {
    window.$catalog_measures_scroll_change = false;

    let result = await omnimap.FillTableAction(
        model,
        page_number,
        window.$catalog_management_units_token
    );

    CallBackFunctions.FillTableCallBack(
        result,
        page_number,
        window.$catalog_measures_column_columnListPure
    );

  }
  /*** ---TABLOYU YENİLEYEN FONKSİYON--- ***/
  reloadData(page_number, ids, short_type, direction, field, active = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          context: [
            {
              role: "Maatregel zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [],
          definitions: [process.env.REACT_APP_CATALOG_MEASURES],
        };
      } else {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          definitions: [process.env.REACT_APP_CATALOG_MEASURES],
          sorting: [],
        };
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          context: [
            {
              role: "Maatregel zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_CATALOG_MEASURES],
        };
      } else {
        model = {
          content: [
            {
              key: "algemeen-actief",
              and_or: "AND",
              values: active,
              datatype: "BOOLEAN",
            },
          ],
          definitions: [process.env.REACT_APP_CATALOG_MEASURES],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }
    window.$catalog_measures_last_used_table_filter = model;
    window.$catalog_measures_context.fillTable(model, page_number).then(() => {
      window.$catalog_measures_context.fillFilterColumns();
    });
  }

  async clickReload(){
    $("#cover-spin").show(0);
    // $("#spinner").removeAttr("hidden");

    await window.$catalog_measures_context.reloadData(1);

    // that.reloadData(1);
  };

  /*** ---TABLOYU YENİLEYEN FONKSİYON--- ***/
  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$catalog_measures_content, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$catalog_measures_content = $.grep(
        window.$catalog_measures_content,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$catalog_measures_content.push(contentModel);
    }

    var model = {
      content: window.$catalog_measures_content,
      definitions: [process.env.REACT_APP_CATALOG_MEASURES],
    };
    window.$catalog_measures_last_used_table_filter = model;
    this.fillTable(model, 1);
  }
  /*** ---COMPONENT AÇILIDĞINDA TABLO SÜTUN ARAMA İNPUTLARININ DOLMASINI SAĞLAYAN FONSİYON--- ***/
  fillFilterColumns(key) {
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_MEASURES],
    };
    $.each(window.$catalog_measures_column_list, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }
  /*** ---TABLOLARIN SÜTÜN ARAMLARININ ANLIK YAPILMASINI SAĞLAYAN FONSİYON--- ***/
  searchFilterColumns(key, searchId) {
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_MEASURES],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$catalog_measures_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  /*****BEGIN ---REACT LIFE CYCLE FUNCTIONS--- BEGIN******/

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_CATALOG_MEASURES],
        };
        that.fillTable(model, 1);
        that.fillFilterColumns();

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_CATALOG_MEASURES],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$catalog_measures_result = [];
          window.$catalog_measures_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$catalog_measures_result);
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_CATALOG_MEASURES],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$catalog_measures_result = [];
            window.$catalog_measures_result.push(that.props.location.state.id);
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(1, window.$catalog_measures_result);
            }
          }
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      window.$catalog_measures_result = [];
      window.$catalog_measures_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$catalog_measures_result);
      }
      $("#cover-spin").hide(0);
    }

    $("#algemeen-code").autocomplete({
      source: window.$catalog_measures_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
  }

  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_MEASURES
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$catalog_measures_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_MEASURES;
        window.$catalog_measures_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_MEASURES;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$catalog_measures_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_MEASURES,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>measures"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : item === "paperclip" ? (
              <th className="sorting_disabled">
                <img
                    className="icon-table"
                    src={bijlage}
                    width={18}
                    height={18}
                />
              </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$catalog_measures_column_columnListPure = result;
      }
    }
    /***************************************************************************************/

    if (window.$catalog_management_units_token == null) {
      window.$catalog_management_units_token = GC.GetToken().then((token) => {
        window.$catalog_management_units_token = token;
        window.$catalog_measures_last_used_table_filter.context
          ? that.fillTable(window.$catalog_measures_last_used_table_filter, 1)
          : this.reloadData(1);
      });
    } else {
      window.$catalog_measures_last_used_table_filter.context
        ? that.fillTable(window.$catalog_measures_last_used_table_filter, 1)
        : this.reloadData(1);
    }

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>measures") {
        window.$catalog_measures_column_list = item["column-list"];
      }
    });

    /*------------------------------------------------------------*/
    /*---------------TABLE İŞLEMLERİ BAŞLANGIÇ--------------------*/
    /*------------------------------------------------------------*/
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,

      scrollX: true, //"500px",
      scrollY: "calc(100vh - 330px)",

      scrollCollapse: true,

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_MEASURES
        );
        window.$catalog_measures_column_columnListPure = result;
      },
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_measures_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_measures_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$catalog_measures_column_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$catalog_measures_page_number++;
                that.fillTable(
                  window.$catalog_measures_last_used_table_filter,
                  window.$catalog_measures_page_number
                );
              }
            }
          }
        }
      }
    });

    /*** ---SETUP - ADD A TEXT İNPUT TO EACH FOOTER CELL--- ***/
    $("#example thead tr").clone(true).appendTo("#example thead");

    $(table.table().header()).addClass("scrollabe-datatable");

    var tes = (document.getElementsByClassName(
      "scrollabe-datatable"
    )[0].parentElement.id = "scrollabe-datatable-id");

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(window.$catalog_measures_column_list, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var nRow = $("#scrollabe-datatable-id thead tr")[0];
      var row_index = table.column(this).index();

      if (row_index != undefined && row_index != 0) {
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (this.className == "sorting_disabled") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_measures_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_measures_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_asc") {
            this.className = "sorting_desc";
            var row;
            $.each(
              window.$catalog_measures_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_measures_result,
              row.shortType,
              "DESCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_desc") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_measures_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_measures_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          }

          window.$catalog_measures_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");
    $("#example tbody").on("dblclick", "tr", function () {
      // var row_id = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      window.$catalog_measures_Glist.forEach(function (item) {
        if (item.identification == rowId) {
          window.$catalog_measures_selectedRow = item;
        }
      });

      CommonFunctions.fillDetail();
      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
    });
    /*** ---OPTİON TO ALLOW SELECTİNG ROWS BY CLİCKİNG ON ROW BESİDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });
    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$catalog_measures_column_columnListPure.column_list[idx] ===
          "checkbox" ||
        window.$catalog_measures_column_columnListPure.column_list[idx] ===
          "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$catalog_measures_last_used_table_filter, 1);
      // that.reloadData(1);
    }
    window.$catalog_measures_refresh = handleRefresh
    $(".refresh").click(handleRefresh);

    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      window.$catalog_measures_selected_ids = selectedIds;

      GetActionsOfRow(selectedIds.join(","));
    });
    /*------------------------------------------------------------*/
    /*---------------TABLE İŞLEMLERİ BİTİŞ------------------------*/
    /*------------------------------------------------------------*/

    /*------------------------------------------------------------*/
    /*---------------ACTION LİST İŞLEMLERİ BAŞLANGIÇ--------------*/
    /*------------------------------------------------------------*/
    $(document).on("click", ".measures-catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_measures_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });

    $("#de_activeer_maatregel").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_GEBIEDEN,
        1,
        30,
        CallBackFunctions.GebiedenCallback,
        window.$catalog_management_units_token
      );
    });

    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
    $(document).on("click", "#mat-map_aanmaken", function () {
      $("#mappen_folder_add_modal").modal("show");
    });
    $(document).on("click", "#mat-verwijderen", function () {
      if (window.$catalog_measures_selected_ids == 0) {
        alert("rows not selected");
      } else {
        $("#measures-mappen_beheren_delete_modal").modal("show");
      }
    });
    /*------------------------------------------------------------*/
    /*---------------ACTION LİST İŞLEMLERİ BİTİŞ------------------*/
    /*------------------------------------------------------------*/

    /*------------------------------------------------------------*/
    /*---------------AUTOCOMPLETE İŞLEMLERİ BAŞLANGIÇ-------------*/
    /*------------------------------------------------------------*/
    $("#algemeen-naam").autocomplete({
      source: window.$catalog_measures_algemeenNaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").autocomplete({
      source: window.$catalog_measures_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-bestekspost").autocomplete({
      source: window.$catalog_measures_algemeenBestekspost,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-bestekspost", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-kwaliteit").autocomplete({
      source: window.$catalog_measures_algemeenKwaliteit,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-kwaliteit", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-omschrijving").autocomplete({
      source: window.$catalog_measures_algemeenOmschrijving,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-omschrijving", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naam").on("input", function () {
      that.searchFilterColumns($(this).val(), this.id);
    });
    $("#algemeen-code").on("input", function () {
      that.searchFilterColumns($(this).val(), this.id);
    });
    $("#algemeen-bestekspost").on("input", function () {
      that.searchFilterColumns($(this).val(), this.id);
    });
    $("#algemeen-kwaliteit").on("input", function () {
      that.searchFilterColumns($(this).val(), this.id);
    });
    $("#algemeen-omschrijving").on("input", function () {
      that.searchFilterColumns($(this).val(), this.id);
    });
    /*------------------------------------------------------------*/
    /*---------------AUTOCOMPLETE İŞLEMLERİ BİTİŞ-----------------*/
    /*------------------------------------------------------------*/
    $(document).on("click", "#measures-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Maatregel zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$catalog_measures_selected_ids,
        "290bc8a2-164d-4c73-8a01-4b9431cd6bea",
        koppelAanFolderCallBack(),
        window.$catalog_management_units_token
      );
    });
    function GetActionsOfRow(rowIds) {
      var rowIdsCount = rowIds.split(",");

      if (rowIdsCount.length >= 1) {
        omnimap
          .GetActionsOfRowAction(rowIds, window.$catalog_management_units_token)
          .then(CallBackFunctions.GetActionsOfRowCallback)
          .catch((error) => {
            console.log(error);
          });
      } else {
        omnimap
          .GetActionsOfRowSingleAction(
            rowIds,
            window.$catalog_management_units_token
          )
          .then(CallBackFunctions.GetActionsOfRowCallback)
          .catch((error) => {
            console.log(error);
          });
      }
    }
    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);

        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }
  }

  render() {
    return (
      <div id="tableSide">
        <div className="buttons_top">
          <a
            href="javascript:void(0)"
            className="button beheer"
            id="mappen_beheren"
          >
            Mappen beheren
          </a>
        </div>
        <div id="c-table-scroll-measures">
          <table
            style={{ width: "100%" }}
            id="example"
            className="table-hover table min-full-width"
          >
            <thead>
              <tr>
                {this.state.columnList}
                {/* <th className="sorting_disabled">
                  <span className="checkAll" />
                  <span className="checkNone" style={{ display: "none" }} />
                </th>
                <th className="sorting_disabled">
                  <img
                    className="icon-table"
                    src={maatregelenSvg}
                    width={18}
                    height={18}
                  />
                </th>
                <th>Naam</th>
                <th>Code</th>
                <th>Bestekspost</th>
                <th>RAW Hoofdcode</th>
                <th>RAW Deficode</th>
                <th>Eenheidsprijs</th>
                <th>Eenheid</th>
                <th>Percentage</th>
                <th>Kwaliteit</th>
                <th>Omschrijving</th>
                <th>Periode voorkeur</th>
                <th>Patroon voorkeur</th> */}
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>

        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
